import { createContext, useContext, useState } from "react";

const UnsavedChangesContext = createContext();

export const UnsavedChangesProvider = ({ children }) => {
    const [isDirty, setIsDirty] = useState(false);

    return (
        <UnsavedChangesContext.Provider value={{ isDirty, setIsDirty }}>
            {children}
        </UnsavedChangesContext.Provider>
    );
};

export const useUnsavedChanges = () => {
    const context = useContext(UnsavedChangesContext);
    if (!context) throw new Error("useUnsavedChanges must be used inside UnsavedChangesProvider");
    return context;
};
